var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRcWarning(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-rc-warning",
    viewBox: "0 0 1024 1024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M512 909.5c219.5334375 0 397.5-177.9665625 397.5-397.5S731.5334375 114.5 512 114.5 114.5 292.4665625 114.5 512s177.9665625 397.5 397.5 397.5z m0 82.5C246.903125 992 32 777.096875 32 512S246.903125 32 512 32s480 214.903125 480 480-214.903125 480-480 480z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M553.25 272c0-22.78125-18.46875-41.25-41.25-41.25s-41.25 18.46875-41.25 41.25v318.27375c0 22.7821875 18.46875 41.25 41.25 41.25s41.25-18.4678125 41.25-41.25V272z m-41.25 401.25c-33.136875 0-60 26.863125-60 60 0 33.136875 26.863125 60 60 60 33.136875 0 60-26.863125 60-60 0-33.136875-26.863125-60-60-60z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRcWarning);
export default __webpack_public_path__ + "static/media/rc-warning.8f767f93291d7a85900ec25f080b4fc7.svg";
export { ForwardRef as ReactComponent };